import React, { useState, useEffect, useRef } from 'react';
import { Search as SearchIcon } from 'lucide-react';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [query, setQuery] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearch(query);
    }, 400);

    return () => clearTimeout(timeout);
  }, [query, onSearch]);

  // Fechar quando clicar fora
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.parentElement?.contains(e.target as Node)
      ) {
        setIsExpanded(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleExpand = () => {
    setIsExpanded(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 150);
  };

  return (
    <div
      className={`
        flex items-center bg-white border rounded-lg shadow-sm px-1 py-1 sm:px-2 sm:py-2 lg:px-3 lg:py-2
        transition-all duration-300 ease-in-out
        ${isExpanded ? 'w-full max-w-md' : 'w-20 justify-center'}
        md:w-full md:max-w-md md:justify-start
      `}
      onClick={() => {
        if (!isExpanded) handleExpand();
      }}
    >
      <SearchIcon className="text-gray-400 mr-2" size={18} />
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Pesquisar no Clube do Livro"
        className={`
          bg-transparent outline-none text-sm
          transition-opacity duration-200
          ${isExpanded || window.innerWidth >= 768 ? 'opacity-100 w-full' : 'opacity-0 w-0'}
        `}
      />
    </div>
  );
};

export default SearchBar;
